import React, { Component, cloneElement } from 'react';
import { List, CreateButton, Datagrid, TextField, DateField, ReferenceField, EditButton, DeleteButton, TopToolbar, RefreshButton, AutocompleteInput, Filter, ReferenceInput, SelectInput, NumberInput } from 'react-admin';
import { Scrollbars } from 'react-custom-scrollbars';
import { GetCurrentUserRoles, monthList } from '../common/common';

import Modal from 'react-responsive-modal';

const LoyaltyPointsFilter = (props) => {
    const noOftargets = [...Array(3).keys()];
    console.log("LoyaltyPointsFilter prop===>", props);
    return (
        <Filter {...props}>
            <ReferenceInput label="Sold To" source="business_id" reference="businesses" linkType="show" allowEmpty>
                <AutocompleteInput optionText="name" />
            </ReferenceInput>
            <SelectInput source="month" label="Month" choices={[
                { id: 1, name: 'January' },
                { id: 2, name: 'February' },
                { id: 3, name: 'March' },
                { id: 4, name: 'April' },
                { id: 5, name: 'May' },
                { id: 6, name: 'June' },
                { id: 7, name: 'July' },
                { id: 8, name: 'August' },
                { id: 9, name: 'September' },
                { id: 10, name: 'October' },
                { id: 11, name: 'November' },
                { id: 12, name: 'December' },
            ]} />
            <SelectInput source="year" label="Year" choices={[
                { id: 2015, name: '2015' },
                { id: 2016, name: '2016' },
                { id: 2017, name: '2017' },
                { id: 2018, name: '2018' },
                { id: 2019, name: '2019' },
                { id: 2020, name: '2020' },
                { id: 2021, name: '2021' },
            ]} />

            <NumberInput source="loyalty_points_gt" label="Loyalty Points Greater than" min={0} max={props.filterValues.loyalty_points_lt} />
            <NumberInput source="loyalty_points_lt" label="Loyalty Points Less than" min={0} />

        </Filter>
    )
}


// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const ListActions = ({ resource, basePath, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters }) => {
    let roleData = GetCurrentUserRoles();
    let createBtn = false;
    if (roleData.indexOf("$csa") > -1 || roleData.indexOf("$ca") > -1) {
        createBtn = true
    }
    return (
        <TopToolbar>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            <RefreshButton />
            {
                createBtn &&
                <CreateButton label="Import" basePath={basePath} />
            }
        </TopToolbar>
    )
}

const MonthName = ({ record = {} }) => {
    return (
        <span>{monthList[Number(record.month) - 1]}</span>
    )
}


class LoyaltyPointsList extends Component {


    render() {
        const { props, permissions } = this;
        const noOftargets = [...Array(3).keys()];
        let roleData = GetCurrentUserRoles();
        let editBtn = false;
        if (roleData.indexOf("$csa") > -1 || roleData.indexOf("$ca") > -1) {
            editBtn = true
        }
        return (
            <React.Fragment>
                <Scrollbars class="scroll-container">
                    <List {...props} exporter={this.exporter} sort={{ field: 'created_at', order: 'DESC' }} undoable={false} filters={<LoyaltyPointsFilter />} title="Loyalty Points" bulkActionButtons={false} actions={<ListActions permissions={permissions} />} >
                        <Datagrid>
                            {/* <UserName label="Sales Officers Name" /> */}
                            <TextField source="sap_code" 
                            // label="Sold To ID" 
                            />
                            {/* <ReferenceField label="Sold To Name" source="business_id" reference="businesses" link="show" allowEmpty >
                                <TextField source="name" />
                            </ReferenceField> */}
                            <TextField source="business_name" label="Sold To Name" />
                            <MonthName source="month" label="Month" />
                            <TextField source="year" label="Year" />
                            <TextField source="points" label="Loyalty Points" />
                            <DateField source="created_at" 
                            // label="Record Created At" 
                            showTime={true} />
                            {
                                editBtn &&
                                <EditButton />
                            }
                            {
                                editBtn &&
                                <DeleteButton />
                            }
                        </Datagrid>
                    </List>
                </Scrollbars>
            </React.Fragment>
        )
    }
}

export default LoyaltyPointsList;